/******************************************************************************************
 *	CSV string to Array
 *******************************************************************************************
 *
 * Converts a CSV-formatted string into an Array
 * Each row of the CSV will be an entry in the array. Each entry will be an array with an entry for each column.
 * Example input:
 *  foo,bar,123
 *  bar,foo,456
 * Example output:
 * [["foo","bar","123"],["bar","foo","456"]]
 *
 */
(function() {
  

  angular.module('rcServices.csvToArray', []).service('CsvToArray', function(_) {
    this.convert = function(csvString) {
      if (!csvString || csvString.length === 0) {
        return [];
      }

      // default field delimiter to comma; if no commas, then try tab
      var strDelimiter = ',';
      if (!_.includes(csvString, strDelimiter)) {
        strDelimiter = '\t';
      }

      // Code below adapted from:
      // http://www.bennadel.com/blog/1504-ask-ben-parsing-csv-strings-with-javascript-exec-regular-expression-command.htm

      // Create a regular expression to parse the CSV values.
      var objPattern = new RegExp(
        // Delimiters.
        '(\\' +
          strDelimiter +
          '|\\r?\\n|\\r|^)' +
          // Quoted fields.
          '(?:"([^"]*(?:""[^"]*)*)"|' +
          // Standard fields.
          '([^"\\' +
          strDelimiter +
          '\\r\\n]*))',
        'gi'
      );
      // Create an array to hold our data. Give the array
      // a default empty first row.
      var arrData = [[]];
      // Create an array to hold our individual pattern
      // matching groups.
      var arrMatches = objPattern.exec(csvString);
      // Keep looping over the regular expression matches
      // until we can no longer find a match.
      while (arrMatches) {
        // Get the delimiter that was found.
        var strMatchedDelimiter = arrMatches[1];
        // Check to see if the given delimiter has a length
        // (is not the start of string) and if it matches
        // field delimiter. If it does not, then we know
        // that this delimiter is a row delimiter.
        if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
          // Since we have reached a new row of data,
          // add an empty row to our data array.
          arrData.push([]);
        }
        // Now that we have our delimiter out of the way,
        // let's check to see which kind of value we
        // captured (quoted or unquoted).
        var strMatchedValue;
        if (arrMatches[2]) {
          // We found a quoted value. When we capture
          // this value, unescape any double quotes.
          strMatchedValue = _.replace(arrMatches[2], new RegExp('""', 'g'), '"');
        } else {
          // We found a non-quoted value.
          strMatchedValue = arrMatches[3];
        }
        // Now that we have our value string, let's add
        // it to the data array.
        arrData[arrData.length - 1].push(strMatchedValue);
        // set up for the next time through the loop (if applicable)
        arrMatches = objPattern.exec(csvString);
      }
      // Return the parsed data.
      return arrData;
    };
  });
})();
